<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="国家" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['country', validatorRules.country]" placeholder="请输入国家"></a-input>
        </a-form-item>
        <a-form-item label="经度" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['longitude', validatorRules.longitude]" placeholder="请输入经度"></a-input>
        </a-form-item>
        <a-form-item label="纬度" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['latitude', validatorRules.latitude]" placeholder="请输入纬度"></a-input>
        </a-form-item>
        <a-form-item label="海报图" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-upload
            :uploadData="uploadData2"
            v-decorator="['posterImage', validatorRules.posterImage]"
            :trigger-change="true"
          ></j-upload>
        </a-form-item>
        <a-form-item label="是否禁用" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-switch v-decorator="['delFlag', validatorRules.delFlag]" checked-children="是" un-checked-children="否" />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { httpAction } from '@/api/manage'
import pick from 'lodash.pick'
import { validateDuplicateValue } from '@/utils/util'
import JUpload from './JUpload'

export default {
  name: 'BusInfoShopCountryModal',
  components: {
    JUpload,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {
        country: { rules: [{ required: true, message: '请输入国家' }] },
        longitude: { rules: [{ required: true, message: '请输入经度' }] },
        latitude: { rules: [{ required: true, message: '请输入纬度' }] },
        posterImage: { rules: [] },
      },
      url: {
        add: '/infoshop.base/busInfoShopCountry/add',
        edit: '/infoshop.base/busInfoShopCountry/edit',
      },
    }
  },
  created() {},
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record, { delFlag: record.delFlag == '1' ? true : false })
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'country', 'longitude', 'latitude', 'posterImage', 'delFlag'))
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'post'
          }
          values.delFlag = values.delFlag ? '1' : '0'
          let formData = Object.assign(this.model, values)
          console.log('表单提交数据', formData)
          httpAction(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        }
      })
    },
    handleCancel() {
      this.close()
    },
    popupCallback(row) {
      this.form.setFieldsValue(pick(row, 'country', 'longitude', 'latitude', 'posterImage', 'delFlag'))
    },
    uploadData2() {
      return {
        filePath: 'infoshop',
      }
    },
  },
}
</script>
